<!-- 승인회원 -->
<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <form @submit.prevent="submitForm">
        <div class="container">
          <div class="area_wrap">
            <div class="title_wrap">
              <h3>개인정보 입력</h3>
              <p class="warn">*필수입력정보입니다.</p>
            </div>
              <div class="aw_context">
                <div class="article require" :class="{errorLaise : form.id.hasError}">
                  <div class="inputHeader">
                    <p>아이디</p>
                    <span class="warn"  v-text="form.id.errorTxt" v-if="form.id.hasError"></span>
                  </div>
                  <input type="text" placeholder="아이디를 입력해주세요." v-model="form.id.value" maxlength="21" @keyup="blurName()" class="idInput"/>
                </div>
                <div class="article require" :class="{errorLaise : form.mail.hasError}">
                  <div class="inputHeader">
                    <p>이메일</p>
                    <span class="warn"  v-text="form.mail.errorTxt" v-if="form.mail.hasError"></span>
                  </div>
                  <input type="text" placeholder="이메일을 입력해주세요." v-model="form.mail.value" maxlength="30" @keyup="blurEmail()" class="mailInput"/>
                </div>
                <p class="suf-warn">입력하신 이메일로 임시비밀번호를 보내드리니 정확한 주소를 입력해주세요.</p>
              </div>
            </div>
        </div>
      <div class="btnWrap" :class="{visible : form.id.flag && form.mail.flag}">
        <button type="submit" :disabled="!checkAll()">다음</button>
      </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapMutations, mapState } from 'vuex'
// import { Dert } from '@/assets/js/thanQAlert'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '입력한 값을 확인해 주세요.',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '비밀번호 찾기',
        prevUrl: '/'
      },
      form: {
        id: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        mail: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    blurName () {
      this.form.id.flag = false
      this.checkName()
    },
    checkName () {
      if (this.form.id.flag) return true

      const userId = this.form.id.value
      if (userId === '') {
        this.form.id.hasError = true
        this.form.id.errorTxt = '아이디를 입력해주세요.'
        return false
      }
      // const isEng = /^[A-Za-z0-9+]*$/
      // if (!isEng.test(userId)) {
      //   this.form.id.hasError = true
      //   this.form.id.errorTxt = '영문과 숫자를 혼용하여 입력해주세요'
      //   return false
      // }
      this.form.id.flag = true
      this.form.id.hasError = false
      this.form.id.errorTxt = ''
      return true
    },
    blurEmail () {
      this.form.mail.flag = false
      this.checkEmail()
    },
    checkEmail () {
      if (this.form.mail.flag) return true

      const email = this.form.mail.value
      if (email === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      // eslint-disable-next-line no-useless-escape
      const isEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!isEmail.test(email)) {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일 형식에 맞지 않습니다.'
        return false
      }
      this.form.mail.flag = true
      this.form.mail.hasError = false
      this.form.mail.errorTxt = ''
      return true
    },
    checkAll () {
      return !!(this.form.id.flag && this.form.mail.flag)
    },
    submitForm () {
      if (this.checkAll()) {
        this.formAction()
      } else {
        if (!this.form.id.flag) {
          this.popupSet.content = '아이디를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.id.hasError = true
          this.form.id.errorTxt = '아이디를 확인해주세요.'
          document.querySelector('.idInput').focus()
          return false
        }
        if (!this.form.mail.flag) {
          this.popupSet.content = '이메일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.mail.hasError = true
          this.form.mail.errorTxt = '이메일을 확인해주세요.'
          document.querySelector('.mailInput').focus()
          return false
        }
      }
    },
    async formAction () {
      const btn = document.querySelector('.btnWrap button')
      console.log('btn: ', btn)
      btn.setAttribute('disabled', 'disabled')
      btn.parentNode.classList.remove('visible')
      try {
        const userData = {
          id: this.form.id.value,
          mail: this.form.mail.value
        }
        await this.PW_FIND_APPROVAL(userData)
          .then(() => {
            this.$store.commit('SET_ID', this.form.id.value)
            this.$router.push('/passwordFindApprovalDone')
          })
      } catch (error) {
        console.log('error :', error);
        console.log('비밀번호 발급 api에 실패함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          if (error.data.response.message === 'Incorrect Token') {
            this.popupSet.content = '회원 정보가 없습니다.'
          } else {
            this.popupSet.content = errorParser.parse(error)
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        btn.parentNode.classList.remove('visible')
        this.initForm()
      }
    },
    ...mapActions([
      'PW_FIND_APPROVAL'
    ]),
    initForm () {
      this.form.id.value = ''
      this.form.mail.value = ''
    },
    nextDone () {
      this.$router.push({ name: 'idFindDone' })
    }
  },
  created () {
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
</style>
